import React from "react";
import styles from "./Publicite.module.css";
import "./animations.css";
import {animationsDuTexte, NOMS_ANIMATIONS} from "./diaporama";
import {composantFondAnime} from "./fondsAnimes";


/**
 * Une diapositive du mode Publicité : le fond (couleur, fond animé, image ou vidéo), un voile qui l'assombrit, puis les
 * textes, chacun apparaissant à son heure (`debut`) et disparaissant à sa fin (`fin`), par des animations CSS : rien ne
 * se recalcule pendant l'affichage. Remonter le composant (nouvelle clé) rejoue la diapositive depuis le début.
 *
 * @param diapositive  diapositive normalisée dont le fond est affichable (voir diaporama.js)
 * @param base         adresse du serveur, ajoutée devant celle des images et vidéos
 * @param fondProps    propriétés passées au fond animé (images, réglages et horaires du bandeau)
 * @param onFinVideo   appelé à la fin d'une vidéo jouée en entier
 */
export default function Diapositive({diapositive, base = "", fondProps = {}, onFinVideo}) {
    const {fond, duree, assombrir, textes} = diapositive;
    const FondAnime = fond.type === "anime" ? composantFondAnime(fond.anime) : null;

    let dessous = null;
    if (fond.type === "image") {
        dessous = <img className={`${styles.media} ${styles.imageVivante}`} style={{animationDuration: duree + "s"}} src={base + fond.url} alt=""/>;
    } else if (fond.type === "video") {
        dessous = (
            <video className={styles.media} src={base + fond.url} autoPlay muted playsInline
                   loop={!diapositive.video_entiere} onEnded={onFinVideo}/>
        );
    } else if (FondAnime) {
        dessous = <div className={styles.anime}><FondAnime {...fondProps}/></div>;
    }

    const zones = {haut: [], centre: [], bas: []};
    textes.forEach(t => zones[t.position].push(t));

    return (
        <div className={styles.diapositive} style={{background: fond.couleur}}>
            {dessous}
            {assombrir > 0 && <div className={styles.voile} style={{opacity: assombrir / 100}}/>}
            <div className={styles.zones}>
                {Object.keys(zones).map(position => (
                    <div key={position} className={`${styles.zone} ${styles[position] || ""}`}>
                        {zones[position].map(t => (
                            <p key={t.id} className={`${styles.texte} ${styles[t.taille]} ${styles[t.cadre] || ""}`}
                               style={{color: t.couleur, ...animationsDuTexte(t, duree, NOMS_ANIMATIONS)}}>
                                {t.texte}
                            </p>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
